import React from 'react';
// UI
import {
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Grid,
  Stack,
} from '@mui/material';
import securityImage from '../assets/securityFeatures/secureOasis.svg';
// Components & Utils
import ViewContainer from '../components/shared/ViewContainer';
import ImageWithTextCard from '../components/shared/ImageWithTextCard';
import DownloadAppSection from '../components/shared/DownloadAppSection';
import FAQSection from '../components/shared/FAQSection';
import ImageCard from '../components/shared/ImageCard';
import HalfCircle from '../components/shared/HalfCircle';
import { mechanismsData, partnersData } from '../utils/securityData';
import useDocumentTitle from '../hooks/useDocumentTitle';

/**
 * @function SecurityFeatures
 * @author RCH010
 * @version 1.0
 * @description View for security features
 * @returns {JSX}
 */
const SecurityFeatures = () => {
  useDocumentTitle('Oasis - Seguridad al rentar')
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <ViewContainer>
      <HalfCircle isLeftCircle left='-2em' bottom='30em' />
      <HalfCircle right='-2em' top='20em' opacity='.2' />
      <Box
        sx={{
          zIndex: 1,
          position: 'relative',
          maxWidth: (currTheme) => currTheme.breakpoints.values.lg,
          mx: 'auto',
          mt: { xs: 12, md: 18 },
          px: 3,
        }}>
        <Typography sx={{ mb: '-1em' }} variant='h1'>
          Un Oasis {isMobile && '\n'}seguro
        </Typography>
        <Stack
          direction={{ xs: 'column', md: 'row-reverse' }}
          justifyContent='center'
          alignItems='center'>
          <img
            src={securityImage}
            alt=''
            style={{
              marginTop: isMobile ? '-1em' : '0',
              marginRight: isMobile ? '-5em' : '0',
              height: isMobile ? '15em' : '30em',
            }}
          />
          <Typography variant='body1'>
            Nuestra misión es crear la plataforma de rentas de palcos y asientos
            VIP para todo tipo de entretenimiento más grande de México, para
            ello, tomamos los criterios más altos de seguridad anti-fraudes para
            que todo tu proceso de renta este protegido, desde tu pago hasta tu
            salida del estadio.
          </Typography>
        </Stack>

        <Typography variant='h2' align='center' sx={{ mt: 15 }}>
          Conoce nuestos mecanismos de seguridad
        </Typography>
        <Box
          sx={{
            mt: 8,
            mb: 15,
          }}>
          <Grid
            container
            spacing={isMobile ? 0 : 5}
            justifyContent='center'
            alignItems='flex-start'>
            {mechanismsData.map((item) => (
              <Grid key={item.id} item xs={12} md={6} sx={{ height: '100%' }}>
                <ImageWithTextCard
                  {...item}
                  backgroundColor='transparent'
                  textColor={theme.palette.common.white}
                  justifyContent='flex-start'
                  imageMaxHeigh={isMobile ? '4.5em' : '7em'}
                  imageMaxWidth={isMobile ? 'auto' : 'auto'}
                  textVariant='body2'
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Typography variant='h2' align='center' sx={{ mt: 15 }}>
          Nuestros convenios nos respaldan
        </Typography>
        <Grid
          container
          spacing={isMobile ? 0 : 2}
          justifyContent='center'
          alignItems='center'>
          {partnersData.map((item) => (
            <Grid key={item.id} item xs={4} sm={3}>
              <ImageCard
                {...item}
                backgroundColor='transparent'
                imageMaxWidth='5em'
              />
            </Grid>
          ))}
        </Grid>
        <Box sx={{ my: 8, zIndex: 1, position: 'relative' }}>
          <DownloadAppSection />
        </Box>
      </Box>
      <FAQSection />
    </ViewContainer>
  );
};

export default SecurityFeatures;
